import React from 'react';
import { connect } from 'react-redux';
import './styles.css';

import { Translations, setElementAttributes } from '../../../utils';
import Modal, { ModalBody, ModalFooter } from '../../common/Modal';
import Checkbox from '../Checkbox';

class Radiobtn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialog: false,
      toggleFlag: false,
      formTouched: false
    };
  }

  setradiovalue = (event) => {
    if (this.props._onChange) {
      this.props._onChange(event);
    }
    if (event.target.name === "financialInstitution" && this.props.toggleBankingNonBankingHelpTextModal && typeof this.props.toggleBankingNonBankingHelpTextModal === 'function') {
      this.props.toggleBankingNonBankingHelpTextModal()
    }
  }

  handleChange = event => {
    if (event.target.name === "RAF-Number-final-acceptance") {
      this.setState({
        RAFNumberfinalacceptance: event.target.checked
      })
    } else {
      this.setState({
        [event.target.name]: event.target.value,
        formTouched: true
      });
      if (event.target.name === "rafNumber") {
        this.props.resetEntity();
      }
    }
  }

  componentDidMount() {
    if (this.props._value !== undefined && (this.props._value.toString() === this.props.value.toString())) {
      const artificialEvent = {
        target: {
          name: this.props.name,
          value: this.props.value
        }
      };
      this.showField(artificialEvent);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.editType !== undefined && this.props.editType === "add-manual-case-basic-details") {
      if (nextProps.name === "financialInstitution" || nextProps.name === "glcmImplementation") {
        if (nextProps.resetData !== undefined) {
          if (nextProps.resetData !== this.props.resetData) {
            if (nextProps._value !== undefined && (nextProps._value.toString() === nextProps.value.toString())) {
              this.setValue(this.props.name, this.props.value)
            }
          }
        }
      }
    }

    if (this.props.editType !== undefined && this.props.editType === "add-manual-case-documentation-details") {
      if (nextProps._value !== this.props._value) {
        if (nextProps._value !== undefined && (nextProps._value.toString() === nextProps.value.toString())) {
          this.setValue(this.props.name, this.props.value)
        }
      }
      if (nextProps.rafPackDetails !== undefined && Object.keys(nextProps.rafPackDetails).length !== 0) {
        if (nextProps.rafPackDetails.isRAFPack !== undefined && nextProps.rafPackDetails.isRAFPack) {
          this.setState({
            rafPackDetails: {
              rafNumber: nextProps.rafPackDetails.newRAFPack.caseId,
              entityFromPack: nextProps.rafPackDetails.newRAFPack.associations[0].name
            },
            RAFNumberfinalacceptance: true
          })
        } else if (nextProps.rafPackDetails.isRAFPack !== undefined && !nextProps.rafPackDetails.isRAFPack) {
          if (nextProps.rafPackDetails.newRAFPack !== null) {
            this.setState({
              rafPackDetails: {
                rafNumber: nextProps.rafPackDetails.newRAFPack.caseId,
                entityFromPack: nextProps.rafPackDetails.newRAFPack.associations[0].name
              },
              RAFNumberfinalacceptance: false
            })
          } else {
            this.setState({ rafPackDetails: undefined })
          }
        }
        else {
          this.setState({
            rafPackDetails: {
              status: nextProps.rafPackDetails.status
            }
          })
        }
      }

    }

    if (this.props.existingEntityData && nextProps.existingEntityData && this.props.existingEntityData.length !== nextProps.existingEntityData.length) {
      if (nextProps.existingEntityData.length >= 1) {
        document.getElementById(this.getFieldId('otherEntityProfileOwner')) && document.getElementById(this.getFieldId('otherEntityProfileOwner')).classList.remove('noDisplay');
        document.querySelectorAll(`[name=otherEntityProfileOwner]`)[0] && document.querySelectorAll(`[name=otherEntityProfileOwner]`)[0].setAttribute('aria-label', 'Please select Profile Owner')
        document.querySelectorAll(`[name=otherProfileOwner]`)[0] && document.querySelectorAll(`[name=otherProfileOwner]`)[0].setAttribute('aria-labelledby', 'other')
        document.getElementById(this.getFieldId('profileOwnerInPack')) && document.getElementById(this.getFieldId('profileOwnerInPack')).classList.add('noDisplay');
        const setValidation = ['country', 'eChannelType', 'eChannelId'];
        this.props.validData(setValidation, 'false');
      }
    }
  }

  setValue(name, value) {
    const artificialEvent = {
      target: {
        name: name,
        value: value
      }
    };
    this.showField(artificialEvent);
  }

  // this method add prefix and suffix on field names to match id's
  getFieldId = (fieldName) => {
    return this.props.fieldPrefix !== undefined ? `${this.props.fieldPrefix}${fieldName}Field` : `${fieldName}Field`;
  }

  normalizeBooleanValues(value) {
    if (value === "true") {
      return true;
    } else if (value === "false") {
      return false;
    } else {
      return value;
    }
  }

  showField = (event) => {
    var setValidation;

    if (this.props.mandatory === "true") {
      this.props.setFieldValidtionState(event.target.name, "valid");
    }

    if (event.target.name === 'newEchannel' && this.props.mode !== 'edit') {
      if (event.target.value === 'true') {
        setValidation = ['profileOwner', 'country', 'eChannelType'];
        this.props.validData(setValidation, 'true');
      }
    }

    if (event.target.name === 'newEchannel' && event.target.value === 'false') {
      setValidation = ['eChannelId', 'profileOwner', 'country', 'eChannelType'];
      this.props.validData(setValidation, 'true');
    }

    if (event.target.name === 'other' && this.props.mode !== 'edit' && event.target.value === 'false') {
      setValidation = ['profileOwner', 'country', 'eChannelType'];
      this.props.validData(setValidation, 'false');
    }

    if (event.target.name === 'surAvailable') {
      if (event.target.value === 'true') {
        setValidation = ['sur'];
        this.props.validData(setValidation, 'false');
      }
    }

    this.props.setInputvalue(this.normalizeBooleanValues(event.target.value), event.target.name);

    if (event.target.name === 'preAllocated') {
      if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('accountNumber')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('branchCode')).classList.add('noDisplay');

      } else if (event.target.value === "true" || event.target.value === true) {
        document.getElementById(this.getFieldId('accountNumber')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('branchCode')).classList.remove('noDisplay');
      }
    } else if (event.target.name === 'newEchannel') {
      document.getElementById(this.getFieldId('swiftBIC')).classList.add('noDisplay');
      if (event.target.value === "true" || event.target.value === true) {
        document.getElementById(this.getFieldId('profileOwner')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('eChannelId')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('other')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('profileOwnerInPack')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('otherEntityProfileOwner')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('otherProfileOwner')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('eChannelIdOptional')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('country')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('eChannelType')).classList.remove('noDisplay');
      } else if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('eChannelId')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('profileOwner')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('other')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('country')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('eChannelType')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('surAvailable')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('sur')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('eChannelIdOptional')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('erpLink')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('singleSignOn')) && document.getElementById(this.getFieldId('singleSignOn')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('ipWhitelisting')) && document.getElementById(this.getFieldId('ipWhitelisting')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'other') {
      if ((event.target.value === "true" || event.target.value === true) && this.props.existingEntityData !== undefined) {
        if (this.props.existingEntityData.length >= 1) {
          document.getElementById(this.getFieldId('otherEntityProfileOwner')).classList.remove('noDisplay');
          document.querySelectorAll(`[name=otherEntityProfileOwner]`)[0].setAttribute('aria-label', 'Please select Profile Owner')
          document.querySelectorAll(`[name=otherProfileOwner]`)[0].setAttribute('aria-labelledby', 'other')
          document.getElementById(this.getFieldId('profileOwnerInPack')).classList.add('noDisplay');
          setValidation = ['country', 'eChannelType', 'otherEntityProfileOwner', 'eChannelId'];
          this.props.validData(setValidation, 'false');
        }
        else {
          document.getElementById(this.getFieldId('otherProfileOwner')).classList.remove('noDisplay');
          document.querySelectorAll(`[name=otherProfileOwner]`)[0].setAttribute('aria-labelledby', 'other otherProfileOwner')
          document.getElementById(this.getFieldId('otherEntityProfileOwner')).classList.add('noDisplay');
          document.getElementById(this.getFieldId('profileOwnerInPack')).classList.add('noDisplay');
          setValidation = ['country', 'eChannelType', 'otherProfileOwner', 'eChannelId'];
          this.props.validData(setValidation, 'false');
        }
      }
      else if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('profileOwnerInPack')).classList.remove('noDisplay');
        document.querySelectorAll(`[name=profileOwnerInPack]`)[0].setAttribute('aria-label', 'Please select Profile Owner In Pack')
        document.getElementById(this.getFieldId('otherProfileOwner')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('otherEntityProfileOwner')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'surAvailable') {
      if (event.target.value === "true" || event.target.value === true) {
        document.getElementById(this.getFieldId('sur')).classList.remove('noDisplay');
      } else if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('sur')).classList.add('noDisplay');
      }
    }
    else if (event.target.name === 'otherAccountHolder') {
      if ((event.target.value === "true" || event.target.value === true) && this.props.existingEntityData !== undefined) {
        if (this.props.existingEntityData.length >= 1) {
          document.getElementById(this.getFieldId('otherEntityAccountHolder')).classList.remove('noDisplay');
          document.getElementById(this.getFieldId('tradingName')).classList.add('noDisplay');
          document.getElementById(this.getFieldId('accountHolder')).classList.add('noDisplay');
        } else {
          document.getElementById(this.getFieldId('tradingName')).classList.remove('noDisplay');
          document.getElementById(this.getFieldId('otherEntityAccountHolder')).classList.add('noDisplay');
          document.getElementById(this.getFieldId('accountHolder')).classList.add('noDisplay');
        }
      }
      else if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('accountHolder')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('tradingName')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('otherEntityAccountHolder')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'glcmImplementation' || event.target.name === 'GLCMImplementation') {
      if (event.target.value === "true" || event.target.value === true) {
        if (document.getElementById(this.getFieldId('projectNo'))) {
          document.getElementById(this.getFieldId('projectNo')).classList.remove('noDisplay');
        } else {
          document.getElementById(this.getFieldId('csProjectNumber')).classList.remove('noDisplay');
        }
      } else {
        document.getElementById(this.getFieldId('projectNo')) && document.getElementById(this.getFieldId('projectNo')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('csProjectNumber')) && document.getElementById(this.getFieldId('csProjectNumber')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('cmpProjectID')) && document.getElementById(this.getFieldId('cmpProjectID')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'projectNo') {
      if (event.target.value === "CS") {
        document.getElementById(this.getFieldId('csProjectNumber')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('cmpProjectID')).classList.add('noDisplay');
        setValidation = ['csProjectNumber'];
        this.props.validData(setValidation, 'false');
      } else if (event.target.value === "CMP") {
        document.getElementById(this.getFieldId('cmpProjectID')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('csProjectNumber')).classList.add('noDisplay');
        setValidation = ['cmpProjectID'];
        this.props.validData(setValidation, 'false');
      }
    }
    else if (event.target.name === 'specificFundRequest') {
      if (event.target.value === "specific") {
        document.getElementById(this.getFieldId('fundAmount')).classList.remove('noDisplay');
      } else {
        document.getElementById(this.getFieldId('fundAmount')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'hsbcAccount') {
      if (event.target.value === "hsbc") {
        document.getElementById(this.getFieldId('addressLine1')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('addressLine2')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('addressLine3')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('city')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('state')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('postCode')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('bankName')).classList.add('noDisplay');
      } else {
        document.getElementById(this.getFieldId('addressLine1')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('addressLine2')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('addressLine3')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('city')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('state')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('postCode')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('bankName')).classList.remove('noDisplay');
      }
    } else if (event.target.name === 'otherAccount') {
      if (event.target.value === "true" || event.target.value === true) {
        document.getElementById(this.getFieldId('accountHolder')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('entityNameOther')).classList.remove('noDisplay');
      } else if (event.target.value === "false" || event.target.value === false) {
        document.getElementById(this.getFieldId('accountHolder')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('entityNameOther')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'accountLimit') {
      if (event.target.value === "false") {
        document.getElementById(this.getFieldId('limitType')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('currency')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('lendingLimit')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('lendingLimitBreachAction')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('borrowingLimit')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('borrowingLimitBreachAction')).classList.add('noDisplay');
      } else {
        document.getElementById(this.getFieldId('limitType')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('currency')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('lendingLimit')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('lendingLimitBreachAction')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('borrowingLimit')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('borrowingLimitBreachAction')).classList.remove('noDisplay');
      }
    } else if (event.target.name === 'polishResident') {
      if (event.target.value === 'true') {
        document.getElementById(this.getFieldId('polishResidentId')).classList.remove('noDisplay');
        document.getElementById(this.getFieldId('dateOfBirth')).classList.add('noDisplay');
      } else {
        document.getElementById(this.getFieldId('polishResidentId')).classList.add('noDisplay');
        document.getElementById(this.getFieldId('dateOfBirth')).classList.remove('noDisplay');
      }

    } else if (event.target.name === "sweepTimeType") {
      if (event.target.value === "customTime") {
        document.getElementById(this.getFieldId('sweepTimeZone')).classList.add('noDisplay');

      } else {
        document.getElementById(this.getFieldId('sweepTimeZone')).classList.add('noDisplay');
      }
    } else if (event.target.name === 'accountRegion' && document.getElementById(this.getFieldId('holidayAdjustmentOption')) !== null) {
      if (event.target.value === 'crossBorder') {
        document.getElementById(this.getFieldId('holidayAdjustmentOption')).classList.remove('noDisplay');
      } else {
        document.getElementById(this.getFieldId('holidayAdjustmentOption')).classList.add('noDisplay');
      }
    } else if (`${event.target.name}${this.props._index}` === `previouslySignedAccountSignatoryDeclarationForm${this.props._index}`) {
      if (event.target.value === 'false') {
        document.getElementById(`sexField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`placeOfBirthField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`countryOfCitizenshipField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`personalHomeAddressField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`typeOfProvidedIdCardField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`documentIdNumberField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`placeOfIssueField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`issuingAuthorityField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`issuingAuthorityField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`signDateOfIssueField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`signExpirationDateField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`personalResidenseField${this.props._index}`).classList.remove('noDisplay');
        document.getElementById(`fiscalCodeField${this.props._index}`).classList.remove('noDisplay');
      } else if (event.target.value === 'true') {
        document.getElementById(`sexField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`signDateOfIssueField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`signExpirationDateField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`personalResidenseField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`fiscalCodeField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`placeOfBirthField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`countryOfCitizenshipField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`personalHomeAddressField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`typeOfProvidedIdCardField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`documentIdNumberField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`placeOfIssueField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`issuingAuthorityField${this.props._index}`).classList.add('noDisplay');
        document.getElementById(`issuingAuthorityField${this.props._index}`).classList.add('noDisplay');

      }
    }
    if (event.target.name === 'CaseRecordType' && this.props.reload !== true) {
      this.props.resetCaseID();
      if (event.target.value === "1") {
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].removeAttribute("readonly");
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].removeAttribute("disabled");
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].value = '';

        if (document.getElementById("CaseID" + this.props.randomIdx)) {
          setElementAttributes(document.getElementById("CaseID" + this.props.randomIdx), { remove: ["readonly", "disabled"], value: "" })
        }

        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[0].style.display="block"
        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[0].disabled=true
        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[1].style.display="none"

        if (document.getElementById("manual_case-button_checkAvailability")) {
          setElementAttributes(document.getElementById("manual_case-button_checkAvailability"), { disabled: true, style: { display: "block" } })
        }
        if (document.getElementById("manual_case-button_search")) {
          setElementAttributes(document.getElementById("manual_case-button_search"), { style: { display: "none" } })
        }

        // document.getElementsById('customer-search-container').style.display="block"
        if (document.getElementById('customer-search-container')) {
          setElementAttributes(document.getElementById('customer-search-container'), { style: { display: "block" } })
        }
        //  document.getElementById('searchText').readOnly = true;
        if (document.getElementById('searchText')) {
          setElementAttributes(document.getElementById('searchText'), { readOnly: true })
        }

      } else if (event.target.value === "2") {
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].removeAttribute("readonly");
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].removeAttribute("disabled");
        // document.getElementById('CaseIDField').childNodes[1].childNodes[0].childNodes[0].value = '';

        if (document.getElementById("CaseID" + this.props.randomIdx)) {
          setElementAttributes(document.getElementById("CaseID" + this.props.randomIdx), { remove: ["readonly", "disabled"], value: "" })
        }

        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[1].style.display="block"
        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[1].disabled=true
        // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[0].style.display="none"

        if (document.getElementById("manual_case-button_checkAvailability")) {
          setElementAttributes(document.getElementById("manual_case-button_checkAvailability"), { style: { display: "none" } })
        }
        if (document.getElementById("manual_case-button_search")) {
          setElementAttributes(document.getElementById("manual_case-button_search"), { disabled: true, style: { display: "block" } })
        }

        // document.getElementById('searchText').readOnly = true;
        if (document.getElementById('searchText')) {
          setElementAttributes(document.getElementById('searchText'), { readOnly: true })
        }

        // document.getElementsById('customer-search-container').style.display="none"
        if (document.getElementById('customer-search-container')) {
          setElementAttributes(document.getElementById('customer-search-container'), { style: { display: "none" } })
        }
      }
      if (document.getElementById("manual_case-msa_2011")) {
        setElementAttributes(document.getElementById("manual_case-msa_2011"), { remove: ["disabled"] })
      }
    }

    if (event.currentTarget !== undefined && event.target.name === 'outputDocumentType' && event.target.value === "2") {
      this.toggleDialog("");
    } else if (event.currentTarget !== undefined && event.target.name === 'outputDocumentType' && event.target.value === "1") {
      this.props.resetValues();
      this.props.setInputvalue("", "RAF");
    }
  }

  handleEnterKey = (e) => {
    if (e.keyCode === 13)
      e.preventDefault();
  }

  toggleDialog = (action) => {
    if (action === "close" && !this.props.rafPackDetails.isRAFPack) {
      this.props.resetValues();
      this.props.setInputvalue("", "outputDocumentType");
      this.props.setFieldValidtionState("outputDocumentType", "invalid");
      this.props.setInputvalue("", "RAF");
      this.setState({ formTouched: false })
    }
    this.setState({
      showDialog: !this.state.showDialog
    })
  }

  handleBlur = field => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  _onValidate = (e) => {
    this.props.validateRAFNumber(this.state.rafNumber);
    e.preventDefault();
  }

  onSubmit = (e) => {
    if (this.state.RAFNumberfinalacceptance === true) {
      this.toggleDialog("");
      this.setState({ formTouched: false })
      this.props.setInputvalue(this.state.rafNumber, "RAF");
      this.props.onSubmit(this.props.rafPackDetails.newRAFPack);
      e.preventDefault();
    }
  }

  displayError = () => {
    const regexPattern = '^(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])([12]\\d{3})-[0-9]{5}(;[0-9]{5})*$';
    const rafNumber = this.state.rafNumber;
    //const regexPattern = this.props.rafValidationPopup.guidetextbox_RAFModeltext.regex;
    if (rafNumber !== undefined && this.state.formTouched) {
      if (rafNumber.length === 0 || new RegExp(regexPattern).test(rafNumber) === false) {
        return true;
      } else {
        return false;
      }
    }
  }

  render() {
    let checked = false;
    if (this.props._value !== undefined && this.props.value.toString() === this.props._value.toString()) {
      checked = true;
    }
    return (
      <span className={this.props.className ? this.props.className + " Radiocontainer" : 'Radiocontainer'}>
        <input
          className="gdocs-radiobtn"
          type="radio"
          role="radio"
          aria-checked={checked}
          checked={checked}
          name={this.props.name}
          value={this.props.value}
          id={this.props.id}
          onChange={this.setradiovalue}
          disabled={this.props.disabled}
          onClick={this.showField}
          onKeyDown={this.handleEnterKey}
        />
        <span className="checkmark"></span>
        {/* {this.props.name === "CaseRecordType"  ?
          <div key="buttons-wrapper" className="reset-buttons-section">
            <div className="reset-buttons-wrapper">
              <FormButton {...this.props.resetBtnProps} key={"Reset"} _onClick={this.props.onReset} />
            </div></div>
          : ''} */}
        {this.props.rafValidationPopup !== undefined ?
          <RAFValidationPopup
            showDialog={this.state.showDialog}
            {...this.props.rafValidationPopup}
            rafPackDetails={this.state.rafPackDetails}
            toggleDialog={(action) => this.toggleDialog(action)}
            rafNumber={this.state.rafNumber}
            //entityFromPack={this.state.rafPackDetails?this.state.rafPackDetails.entityFromPack:''}
            displayError={this.displayError}
            _onValidate={(e) => this._onValidate(e)}
            _onSubmit={this.onSubmit}
            formTouched={this.state.formTouched}
            confirmationBoxSelected={this.state.RAFNumberfinalacceptance}
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            bsClass="manual-case-documentation-raf-model"
            lang={this.props.lang}
            translatedData={this.props.translatedData}
          /> : ''
        }</span>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    rafPackDetails: state.rafPackDetails,
  }
}
export default connect(mapStateToProps, null)(Radiobtn);



const RAFValidationPopup = (props) => (
  <Modal
    show={props.showDialog}
    onClose={() => props.toggleDialog("close")}
    bsClass={props.bsClass}
  >
    <ModalBody>
      <label className="manual-case-documentation-raf-model-raf-number-label" htmlFor="rafNumber">
        {Translations(props.guidetextbox_RAFModeltext.title, props.lang, props.translatedData)}
      </label>
      <input
        type="text"
        name="rafNumber"
        id="rafNumber"
        aria-describedby="rafNumbererror"
        onChange={props.handleChange}
        value={props.rafPackDetails !== undefined ? props.rafPackDetails.rafNumber : undefined}
      //onBlur={props.handleBlur('rafNumber')}
      />
      <button
        className="gdocs-btn-primary"
        id="validate"
        onClick={props._onValidate}
        disabled={props.rafNumber !== undefined ? props.displayError() || !props.formTouched : true}
      >
        {Translations(props.guidebutton_validate.text, props.lang, props.translatedData)}
      </button>
      {props.rafPackDetails !== undefined && props.rafPackDetails !== "" && props.rafPackDetails.entityFromPack !== undefined && props.rafPackDetails.entityFromPack !== "" ?
        <p id={"entityFromPack"}> {props.rafPackDetails.entityFromPack}</p> : ''}

      {
        props.displayError() ? <div className="input-error-msg-section gdocs-error-align" role="alert" id="rafNumbererror">
          <span className="icon icon-circle-delete-solid"></span>
          {Translations(props.guidetextbox_RAFModeltext.regexValidationMessage, props.lang, props.translatedData)}
        </div> : ""
      }
      {props.rafPackDetails !== undefined && props.rafPackDetails !== "" && props.rafPackDetails.status === 404 ?
        <div className="input-error-msg-section gdocs-error-align" role="alert" id="rafNumbererror">
          <span className="icon icon-circle-delete-solid"></span>
          {Translations(props.guidetextbox_RAFModeltext.mandatoryMessage, props.lang, props.translatedData)}
        </div> : ''
      }
      {props.rafPackDetails !== undefined && props.rafPackDetails !== "" && props.rafPackDetails.entityFromPack !== undefined ?
        <div className="RAF-Number-checkbox">
          <div className="RAF-Number-checkbox-child" style={{ display: "inline-flex" }}>
            <Checkbox
              name="RAF-Number-final-acceptance"
              onChange={props.handleChange}
              defaultChecked={props.confirmationBoxSelected}
            />
            <label htmlFor="RAF-Number-final-acceptance" style={{ marginLeft: "15px" }}>
              {Translations(props.static_text_checkboxtext.label, props.lang, props.translatedData)}
            </label>
            <button
              className="gdocs-btn-secondary"
              disabled={!props.confirmationBoxSelected}
              hidden={props.rafPackDetails.entityFromPack === undefined || props.rafPackDetails.entityFromPack === ""}
              onClick={props._onSubmit}
            >
              {Translations(props.guidebutton_submit.text, props.lang, props.translatedData)}
            </button>
          </div>
        </div> : ''}
    </ModalBody>
    <ModalFooter>


    </ModalFooter>
  </Modal>);



// WEBPACK FOOTER //
// ./src/components/common/Radio/radioButton.js